var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocial1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18644",
    "data-name": "Rectangle 18644",
    width: 22,
    height: 22,
    transform: "translate(836 4167)",
    fill: "#a5a5a5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_53",
    "data-name": "Mask Group 53",
    transform: "translate(-836 -4167)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_98849",
    "data-name": "Group 98849",
    transform: "translate(836.759 4167)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_215693",
    "data-name": "Path 215693",
    d: "M15.693,0H5.825A5.831,5.831,0,0,0,0,5.825v9.869a5.831,5.831,0,0,0,5.825,5.825h9.869a5.831,5.831,0,0,0,5.825-5.825V5.825A5.831,5.831,0,0,0,15.693,0Zm4.563,15.693a4.568,4.568,0,0,1-4.563,4.563H5.825a4.568,4.568,0,0,1-4.563-4.563V5.825A4.568,4.568,0,0,1,5.825,1.261h9.869a4.568,4.568,0,0,1,4.563,4.563Zm0,0",
    transform: "translate(0 0)",
    fill: "#a5a5a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215694",
    "data-name": "Path 215694",
    d: "M121.888,116a5.884,5.884,0,1,0,5.884,5.884A5.89,5.89,0,0,0,121.888,116Zm0,10.506a4.622,4.622,0,1,1,4.622-4.622A4.627,4.627,0,0,1,121.888,126.51Zm0,0",
    transform: "translate(-111.129 -111.129)",
    fill: "#a5a5a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215695",
    "data-name": "Path 215695",
    d: "M359.715,66.285a1.739,1.739,0,1,0,1.739,1.739A1.741,1.741,0,0,0,359.715,66.285Zm0,2.216a.477.477,0,1,1,.477-.477A.478.478,0,0,1,359.715,68.5Zm0,0",
    transform: "translate(-342.932 -63.499)",
    fill: "#a5a5a5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial1);
export default __webpack_public_path__ + "static/media/social1.187e7ddb4e82e6d09a4cf030c34ad654.svg";
export { ForwardRef as ReactComponent };